import React from 'react'
import Permissions from '../../../components/Permissions'


const PermissionsPage = () => {
    return (
        <div class="w-full">
            <Permissions />
        </div>
    )
}

export default PermissionsPage
